import KEYS from '@/values/keys';

export const TOOLS_API = {
  INSTITUTION_INFO: 'organization/myOrganizations/',
  // INSTITUTION_INFO: 'internal/organization/myOrganizations/SDA',
  SDA_INSTITUTION: 'organization',
  UPDATE_INSTITUTION_INFO: 'organization',
  COUNTRIES: 'address/countries',
  CITIES: 'internal/address/cities'
}

export const TOOLS_STORE_NAME = 'ToolsStore';

export const TOOLS_STORE_MUTATIONS = {
  SET_INSTITUTION_INFO: 'setInstitutionInfo',
  SET_INSTITUTION_SDA: 'setInstitutionSDA',
  SET_COUNTRIES: 'setCountries',
  SET_RECENT_ACTIVITIES: 'setRecentActivities',
  CLEAN_RECENT_ACTIVITIES: 'cleanRecentActivities',
}

export const TOOLS_STORE_ACTIONS = {
  GET_INSTITUTION_INFO: 'getInstitutionInfo',
  GET_INSTITUTION_SDA: 'getInstitutionSDA',
  UPDATE_INSTITUTION_INFO: 'updateInstitutionInfo',
  GET_COUNTRIES: 'getCountries',
  GET_RECENT_ACTIVITIES: 'getRecentActivities',
}

export const _TOOLS_STORE = {
  NAME: TOOLS_STORE_NAME,
  MUTATIONS: {
    CLEAN_RECENT_ACTIVITIES: `${TOOLS_STORE_NAME}/${TOOLS_STORE_MUTATIONS.CLEAN_RECENT_ACTIVITIES}`,
  },
  ACTIONS: {
    GET_INSTITUTION_INFO: `${TOOLS_STORE_NAME}/${TOOLS_STORE_ACTIONS.GET_INSTITUTION_INFO}`,
    GET_INSTITUTION_SDA: `${TOOLS_STORE_NAME}/${TOOLS_STORE_ACTIONS.GET_INSTITUTION_SDA}`,
    GET_COUNTRIES: `${TOOLS_STORE_NAME}/${TOOLS_STORE_ACTIONS.GET_COUNTRIES}`,
    UPDATE_INSTITUTION_INFO: `${TOOLS_STORE_NAME}/${TOOLS_STORE_ACTIONS.UPDATE_INSTITUTION_INFO}`,
    GET_RECENT_ACTIVITIES: `${TOOLS_STORE_NAME}/${TOOLS_STORE_ACTIONS.GET_RECENT_ACTIVITIES}`,
  }
}
